import {VStack} from 'platform/foundation';
import {match} from 'ts-pattern';

import {useCallback} from 'react';

import {head, mergeAll} from 'ramda';
import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {catchUnhandledDataGridActions, DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback, QueryFilterObject} from 'features/eag-grid';

import {SharedRequirementsCard} from './components/SharedRequirementsCard';

export function ScheduledMessagesOverview() {
  const navigate = useNavigate();

  const queryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {deliveryType: 'automatic'}]),
    []
  );

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const id = isArray(rowId) ? head(rowId) : rowId;

    match(actionKey)
      .with('detail', () =>
        navigate(composePath(settingsRoutes.scheduledMessagesDetail, {params: {id}}))
      )
      .otherwise(catchUnhandledDataGridActions);
  };

  return (
    <SettingsTemplate
      header={{title: i18n.t('page.settings.labels.scheduledMessages')}}
      data-testid="settings-scheduled-messages-overview"
    >
      <VStack spacing={6}>
        <SharedRequirementsCard data-testid="settings-scheduled-messages-overview" />
        <DmsDataGrid
          gridCode="messaging-customer-message"
          actionCallback={actionCallback}
          autoHeight
          queryModifier={queryModifier}
        />
      </VStack>
    </SettingsTemplate>
  );
}
